import type {Question, QuestionCheckInput} from '@cp/model';
import {questionCheckGptDirect} from '../../api/callable/question';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export function useCheckQuestionWithGptDirect() {
  const {
    fn: checkQuestionWithGptDirect,
    loading,
    error,
  } = useFunctionWrap(
    async (questionInput: QuestionCheckInput, audienceLevel: string): Promise<Question> =>
      questionCheckGptDirect({questionInput, audienceLevel}) as Promise<Question>,
  );

  return {
    checkQuestionWithGptDirect,
    loading,
    error,
  };
}
